import Vue from 'vue'
import BasicButton from '@/components/basic/Button'
import BasicInput from '@/components/basic/Input'

Vue.component('basic-button', BasicButton);
Vue.component('basic-input', BasicInput);
